// extracted by mini-css-extract-plugin
var _1 = "SearchTextInput-moduleSearchTextInput__vc7zM";
export { _1 as "SearchTextInput" }
